import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/checkbox.svg'


const _withScopeId = n => (_pushScopeId("data-v-31ba708e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-with-confirm-use" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, " 賞品の引き換え手続きは一度行うと元に戻せません。賞品を受取済にしますか？ ", -1))
const _hoisted_3 = { class: "container-checkbox" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "確認しました", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "inner",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('check')))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["box-check", { checked: _ctx.isChecked }])
        }, [
          (_ctx.isChecked)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true)
        ], 2),
        _hoisted_5
      ])
    ])
  ]))
}